<template>
  <div class="container column">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/video-play.svg" width="50" alt="Minds">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <h2 class="animation-top animation-delay-02"><span>FINANCIAL</span></h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Veja as informações de sua ficha financeira.</p>
      </div>
    </div>
    <div class="box-content shadow-box box-content-border hidden min-height container justify-content-center align-items-center">

<!-- INICIO BOX FINANCEIRO -->
      <div class="box--item animation-bottom animation-delay-05 expenses">
        <div class="expenses__item" v-for="(exp, key) in expenses" :key="key">
          <div class="expenses__item__svg" :class="[getClass(exp.state)]">

            <div>
              <font-awesome-icon icon="dollar-sign"/>
            </div>

            <div>
              <p>{{ getState(exp.state) }}</p>
            </div>

          </div>

          <div class="expenses__item__info">
            <div class="expenses__item__info__field expenses__item__info__field--main">

              <div class="expenses__item__info__field__box container">
              <p style="flex-grow: 1; flex-basis: 100px; background: #c70c34; color: white;">Item</p>
              <span style="flex-grow: 2;">{{ exp.title }} {{ exp.status }}</span>
              </div>

            </div>
            <div class="expenses__item__info__field expenses__item__info__field-info">

              <div class="expenses__item__info__field__box container">
                <p style="background: #c70c34; color: white;">INSTALLMENT:</p>
                <span>{{ exp.installment }} / {{ exp.installments }}</span>
              </div>

            </div>

            <div class="expenses__item__info__field expenses__item__info__field--to-pay">

              <div class="expenses__item__info__field__box container">
                <p>Due Date:</p>
                <span>{{ $toDate(new Date(exp.due_date)).split(' ').shift() }}</span>
              </div>

              <div class="expenses__item__info__field__box container">
                <p>Time:</p>
                <span>{{ $toDate(new Date(exp.due_date)).split(' ').pop() }}</span>
              </div>

              <div class="expenses__item__info__field__box container">
                <p>Value:</p>
                <span>R$ {{ $toCurrency(exp.amount) }}</span>
              </div>

            </div>

            <div class="expenses__item__info__field expenses__item__info__field--paid" v-if="exp.payday">
              <p>Pay Day:<span></span> {{ $toDate(new Date(exp.payday)).split(' ').shift() }}</p>
              <p>Time:<span></span> {{ $toDate(new Date(exp.payday)).split(' ').pop() }}</p>
              <p>Value:<span></span> R$ {{ $toCurrency(exp.paid_amount) }}</p>
            </div>

            <div class="expenses__item__info__field expenses__item__info__field--paid" v-else>
              <p class="expenses__item__info__field__box">Not paid yet</p>
            </div>
          </div>

        </div>

      </div>
<!-- INICIO BOX FINANCEIRO -->


    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      expenses () {
        return this.$store.getters['financial/getExpenses']
      }
    },
    methods: {
      getState (state) {
        switch (state) {
          case 'C':
            return 'CANCELADO'
          case 'A':
            return 'ABERTO'
          // RECEBIDO
          case 'R':
            return 'PAGO'
          case 'V':
            return 'VENCIDO'
          // TROCADO
          case 'T':
            return 'CHEQUE TROCADO'
          case 'D':
            return 'DEVOLVIDO'
          // BAIXADO
          case 'B':
            return 'PAGO'
          default:
            return 'CANCELADO'
        }
      },
      getClass (state) {
        switch (state) {
          case 'C':
            return 'canceled'
          case 'A':
            return 'open'
          // RECEBIDO
          case 'R':
            return 'closed'
          case 'V':
            return 'canceled'
          // TROCADO
          case 'T':
            return 'canceled'
          case 'D':
            return 'canceled'
          // BAIXADO
          case 'B':
            return 'closed'
          default:
            return 'closed'
        }
      }
    },
    async created () {
      await this.$store.dispatch('financial/getExpenses')
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../assets/css/base/variables';

  .expenses {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    &__item {
      // flex-basis: 100px;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-wrap: wrap;
      background-color: #FFB300;
      border-radius: 15px;
      &:not(:first-child) {
        margin-top: 20px;
      }
      &__svg {
        // padding: 10px 15px;
        // padding-right: 0;
        flex-basis: 115px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 20px;


        &.closed {
          color: $color-green;
          background: #e2e2e2;
          margin: 15px 0px 15px 20px;
          border: 3px solid $color-green;
          p{
            color: rgb(185, 255, 220);
            background: $color-green;
            padding: 5px 15px;
            margin-top: 10px;
            border-radius: 30px;
            }
        }
        &.canceled {
          color: rgb(255, 255, 255);
          background: #e2e2e2;
          margin: 15px 0px 15px 20px;
          border: 3px solid #C81030;
           p{
            color: #FFB9C3;
            background: #C81030;
            padding: 5px 15px;
            margin-top: 10px;
            border-radius: 30px;
            }
        }
        &.open {
          color: $color-yellow;
          background: #e2e2e2;
          margin: 15px 0px 15px 20px;
          border: 3px solid $color-yellow;
            p{
              color: rgb(255, 230, 185);
              background: rgb(252, 155, 9);
              padding: 5px 15px;
              margin-top: 10px;
              border-radius: 30px;
              }
        }
        svg {
          font-size: 30px;
          background-color: #FF929F;
          width: 80px;
          height: 80px;
          padding: 15px 15px;
          border-radius: 50%;
        }
        p {
          padding-top: 5px;
        }
      }
      &__info {
        padding: 10px 15px;
        flex-basis: 220px;
        flex-grow: 10;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: stretch;
        &__field {
          background-color: #E2E2E2;
          padding: 5px 15px;
          margin: 5px;
          border-radius: 15px;
          flex-grow: 1;
          flex-basis: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          &--main {
            flex-basis: 225px;
          }
          &--to-pay {
            flex-basis: 225px;
          }
          p{
            padding: 3px 15px;
            background: #FFB300;
            color: #8D250F;
            border-radius: 30px;
            margin: 5px 0px;
            width: 100%;
            text-align: center;
            font-weight: 400;
          }
          span{
            padding: 3px 15px;
            background: #BFBFBF;
            color: #515151;
            border-radius: 30px;
            margin: 5px 0px 5px 5px;
            font-weight: 300;
            width: 100%;
            text-align: center;
            }
          &__box{
            display: flex;
            font-size: 14px;
            width: 100%;
            justify-content: space-evenly;
          }
        }
      }
    }
  }

  @media screen and (max-width: 411px) {
    .expenses__item__svg {
      padding-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/financial/index.vue